<template>
    <div class="contenedor_modal" style="background-color: rgba(0, 0, 0, 0.1) !important;">
        <div class="contenedor_modal_cuerpo" style="height: 600px !important;">
            <div class="contenedor_modal_cabecera">
                <b-button type="button" size="sm" variant="danger" v-shortkey="['esc']" @shortkey="cerrar"
                    @click="cerrar"><i class="fas fa-times"></i></b-button>
            </div>

            <b-container fluid="">
                <form @submit.prevent="guardar">
                    <b-row>
                        <div class="col-sm-12 mt-3">
                            <h3 v-if="modulo_del_que_viene == 'sucursales'">
                                Crear artículo en sucursal
                            </h3>
                            <h3 v-else>
                                Crear artículo en bodega central
                            </h3>
                        </div>

                        <div class="col-sm-4 mt-3">
                            <label for="" class="form-label">Código</label>
                            <input type="text" id="campo_codigo_articulo" class="form-control form-control-sm" required
                                v-model="codigo">
                        </div>
                        <div class="col-sm-8 mt-3">
                            <label for="" class="form-label">Nombre</label>
                            <input type="text" class="form-control form-control-sm" required v-model="nombre">
                        </div>

                        <div class="col-sm-3 mt-3">
                            <label for="" class="form-label">Marca</label>
                            <select class="form-control form-control-sm" v-model="marca" required>
                                <option value="">Selecciona marca</option>
                                <option v-for="(item, index) in marcas_" :key="index" :value="item.id">{{ item.marca }}
                                </option>
                            </select>
                        </div>

                        <div class="col-sm-3 mt-3">
                            <label for="" class="form-label">Precio de costo</label>
                            <input type="number" step="0.01" min="1" required class="form-control form-control-sm"
                                v-model="precio_costo">
                        </div>

                        <div class="col-sm-3 mt-3">
                            <label for="" class="form-label">Precio de venta</label>
                            <input type="number" step="0.01" min="1" required class="form-control form-control-sm"
                                v-model="precio_venta">
                        </div>

                        <div class="col-sm-3 mt-3">
                            <label for="" class="form-label">Precio de efectivo</label>
                            <input type="number" step="0.01" min="1" required class="form-control form-control-sm"
                                v-model="precio_efectivo">
                        </div>

                        <div class="col-sm-4 mt-3">
                            <label for="" class="form-label">Existencia inicial</label>
                            <input type="number" class="form-control form-control-sm" required
                                v-model="existencia_minima">
                        </div>

                        <div class="col-sm-4 mt-3">
                            <label for="" class="form-label">Medida</label>
                            <select class="form-control form-control-sm" required v-model="medida">
                                <option value="">Seleccionar</option>
                                <option v-for="(item, index) in unidades_" :key="index" :value="item.id">{{
                                    item.descripcion }}</option>
                            </select>
                        </div>

                        <div class="col-sm-4 mt-3">
                            <label for="" class="form-label">Tipo de producto</label>
                            <select class="form-control form-control-sm" required v-model="tipo_de_producto">
                                <option value="">Seleccionar</option>
                                <option value="1">Materia Prima</option>
                                <option value="2">Comprado</option>
                                <option value="3">Fabricado</option>
                            </select>
                        </div>


                        <div class="col-sm-12 mt-3">
                            <label for="" class="form-label">Descripción</label>
                            <input type="text" placeholder="(Opcional)" class="form-control form-control-sm"
                                v-model="descripcion">
                        </div>

                        <div class="col-sm-12 mt-3">
                            <label for="" class="form-label">Imagen</label>
                            <b-form-file v-model="foto_producto" required :state="Boolean(foto_producto)"
                                placeholder="Elije archivo o déjalo caer aquí..."
                                drop-placeholder="Arrastra archivo aquí..." size="sm"></b-form-file>

                        </div>

                        <div class="col-sm-12 mt-3 mb-3">
                            <button type="submit" class="btn btn-sm btn-outline-dark btn-block" :disabled="guardando">
                                <span v-if="guardando">
                                    <span class="spinner-border spinner-border-sm" role="status"
                                        aria-hidden="true"></span>
                                    Guardando...
                                </span>
                                <span v-else>Guardar</span>
                            </button>
                        </div>
                    </b-row>
                </form>
            </b-container>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import { mapActions, mapGetters, mapState } from 'vuex'
import { atexto } from '../../functions/alertas'
export default {
    name: 'CrearArticulo',
    props: ['modulo_del_que_viene'],
    computed: {
        ...mapGetters(['URL_SERVIDOR', 'TOKEN_FORMATEADO']),
        ...mapState(['unidades_', 'marcas_', 'sucursal_seleccionada'])
    },
    data() {
        return {
            codigo: '',
            nombre: '',
            existencia_minima: '',
            descripcion: '',
            marca: '',
            precio_costo: '',
            precio_venta: '',
            precio_efectivo: '',
            medida: '',
            tipo_de_producto: '',
            foto_producto: null,
            guardando: false
        }
    },
    methods: {
        cerrar() {
            this.$emit('salir')
        },
        async guardar() {

            this.guardando = true

            try {
                let formData = new FormData();
                formData.append('files', this.foto_producto)

                let upl = await axios.post(`${this.URL_SERVIDOR}/api/upload`, formData, this.TOKEN_FORMATEADO)

                let id_foto = upl.data[0].id
                let formatos = upl.data[0].formats

                if (upl.status == 200 || upl.status == 201) {

                    let f = {
                        // api: `articulos`,
                        api: `articulos/c/articulo`,
                        formulario: {
                            codigo: this.codigo,
                            nombre: this.nombre.toUpperCase().trim(),
                            existencia_minima: this.existencia_minima === '' ? 0 : this.existencia_minima < 0 ? 0 : this.existencia_minima,
                            descripcion: this.descripcion.trim(),
                            formatos,
                            id_foto,
                            marca: this.marca,
                            precio_costo: this.precio_costo,
                            precio_venta: this.precio_venta,
                            precio_efectivo: this.precio_efectivo,
                            medida: this.medida,
                            tipo_de_producto: parseInt(this.tipo_de_producto),
                            sucursal: this.modulo_del_que_viene == 'inventario_busqueda' ? 0 : this.sucursal_seleccionada.codigo
                        }
                    }

                    await this.guardar_data(f)
                    this.$emit('actualizar_lista_productos')

                    this.codigo = ''
                    this.nombre = ''
                    this.existencia_minima = ''
                    this.descripcion = ''
                    this.marca = ''
                    this.precio_costo = ''
                    this.precio_venta = ''
                    this.precio_efectivo = ''
                    this.medida = ''
                    this.tipo_de_producto = ''
                    this.foto_producto = null

                    document.getElementById('campo_codigo_articulo').focus()

                } else {
                    atexto({
                        titulo: 'Error!',
                        cuerpo: 'Hubo un error al subir la imagen',
                        icono: 'error'
                    })
                }
            } finally {
                this.guardando = false
            }

        },
        ...mapActions(['guardar_data'])
    },
    mounted() {
        document.getElementById('campo_codigo_articulo').focus()
    },
}
</script>

<style></style>
